// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo_logo__UgZyE","link":"logo_link__sIbev","image":"logo_image__SrZY_","pfLogo":"logo_pfLogo__WUfUk"};